module.exports = __webpack_public_path__ + "img/jjzh_bg1.ef8528da.png";